import { axiosPost } from '../ServiceBase.js';

export const findFarmacias = async (data) => {
  const farmacias = await axiosPost('/v1/busquedas/farmacias/buscar', data);
  return farmacias;
};
